import React from 'react'
import { ReactComponent as NoTrafficUserFoundSVG } from '../../../assets/images/nouserfound.svg'
import { ReactComponent as KnowledgeBaseSVG } from '../../../assets/images/KnowledgeBase/KnowledgeBaseSVG.svg'
import { ReactComponent as NoChartFound } from '../../../assets/images/noChartFound.svg'
import { ReactComponent as NoAnalyticFound } from '../../../assets/images/noTableFound.svg'
import { useNavigate } from 'react-router-dom'
const NoDataFound = ({ containerStyle = {}, isForKb, isForChart, isForAnalytics, title = 'No customers found', description, showBackButton = true }) => {
  const navigate = useNavigate()
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '70vh',
        ...containerStyle,
      }}
    >
      {isForKb ? <KnowledgeBaseSVG /> : isForChart ? <NoChartFound /> : isForAnalytics ? <NoAnalyticFound /> : <NoTrafficUserFoundSVG />}
      <h1
        style={{
          color: '#061522',
          textAlign: 'center',
          fontSize: '18px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '18px',
          marginTop: '37px',
        }}
      >
        {title}
      </h1>
      {description && (
        <p
          style={{
            color: '#405261',
            textAlign: 'center',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '18px',
            maxWidth: '274px',
            marginTop: '8px',
          }}
        >
          {description}
        </p>
      )}
      {showBackButton && (
        <button
          style={{
            width: '274px',
            height: '40px',
            flexShrink: 0,
            borderRadius: '8px',
            background: '#148DFD',
            boxShadow: '0 1px 2px 0 rgba(6, 21, 34, 0.05)',
            color: '#FFF',
            textAlign: 'center',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '18px',
            marginTop: '27px',
            border: 'none',
            cursor: 'pointer',
          }}

          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </button>
      )}
    </div>
  )
}

export default NoDataFound